import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function LinkHover (props) {

  const [hoverLink, setHoverLink] = useState({
    textDecoration: 'none',
    margin: '16px 10px 0 10px',
    color: '#FFF',
    fontWeight: '700',
    fontSize: `${props.letterSize}`,
    opacity: '0.75',
  });

  return(
      <div>
        <Link
          to={props.pageRef}
          style={hoverLink}
          onMouseEnter={() => setHoverLink({
            textDecoration: 'none',
            margin: '16px 10px 0 10px',
            color: '#FFF',
            fontWeight: '700',
            fontSize: `${props.letterSize}`,
            opacity: '1',
          })}
          onMouseLeave={() => setHoverLink({
            textDecoration: 'none',
            margin: '16px 10px 0 10px',
            color: '#FFF',
            fontWeight: '700',
            fontSize: `${props.letterSize}`,
            opacity: '0.75',
          })}
          >{props.linkName}
        </Link>
    </div>
  )
}

export default LinkHover
